/* WidthPro — product interactivity: gallery swap, variant picker, qty, sticky buy-bar. */
(function () {
  // Gallery thumb swap
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main && thumb.dataset.fullSrc) main.src = thumb.dataset.fullSrc;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  // Variant picker
  document.querySelectorAll('[data-product-options]').forEach(function (root) {
    var product;
    try { product = JSON.parse(root.dataset.productJson); } catch (e) { return; }
    if (!product || !product.variants) return;
    var form = root.closest('form');
    var idInput = form ? form.querySelector('[data-variant-id]') : null;
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('.buybox__price .c');
    var addBtn = form ? form.querySelector('[data-add-to-cart]') : null;
    var qtyInput = form ? form.querySelector('[data-qty-input]') : null;
    var assetGallery = !!document.querySelector('[data-product-gallery][data-asset-gallery]');
    var mainImg = assetGallery ? null : document.querySelector('[data-gallery-main]');
    var unavailable = root.querySelector('[data-option-unavailable]');
    var money = function (c) { return '$' + (c / 100).toFixed(2); };

    var selected = {};
    root.querySelectorAll('[data-option-position]').forEach(function (b) {
      if (b.classList.contains('is-selected')) selected[b.dataset.optionPosition] = b.dataset.optionValue;
    });

    function match() {
      return product.variants.find(function (v) {
        return Object.keys(selected).every(function (pos) { return v.options[parseInt(pos, 10) - 1] === selected[pos]; });
      });
    }
    function apply() {
      var v = match();
      if (!v) { if (unavailable) unavailable.hidden = false; if (addBtn) addBtn.disabled = true; return; }
      if (unavailable) unavailable.hidden = true;
      if (idInput) idInput.value = v.id;
      var q = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var total = q >= 2 ? Math.round(v.price * q * 0.85) : v.price * q;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart — ' + money(total) : 'Sold out';
      }
      if (mainImg && v.featured_image && v.featured_image.src) mainImg.src = v.featured_image.src;
    }

    root.querySelectorAll('[data-option-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.dataset.optionPosition;
        root.querySelectorAll('[data-option-btn][data-option-position="' + pos + '"]').forEach(function (b) {
          b.classList.remove('is-selected'); b.style.borderColor = ''; b.style.color = '';
        });
        btn.classList.add('is-selected'); btn.style.borderColor = 'var(--clay)'; btn.style.color = 'var(--clay)';
        selected[pos] = btn.dataset.optionValue;
        var lbl = root.querySelector('[data-option-selected="' + pos + '"]');
        if (lbl) lbl.textContent = btn.dataset.optionValue;
        apply();
      });
    });
  });

  // Quantity stepper (legacy number input, if present)
  document.querySelectorAll('[data-qty-wrap]').forEach(function (wrap) {
    var input = wrap.querySelector('[data-qty-input]');
    wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.dataset.qtyStep, 10);
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
      });
    });
  });

  // Sticky buy-bar reveal
  var buybar = document.querySelector('[data-buybar]');
  var anchor = document.querySelector('[data-add-to-cart]') || document.querySelector('#buy');
  if (buybar && anchor && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { buybar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(anchor);
  }
})();
